import React from 'react';
import CONFIG from '../../../config';

import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import WidgetInputTextList from '../../../components/widgets/WidgetInputTextList';

import 'dayjs/locale/fr';
import { useNavigate, useParams } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import sha256 from 'crypto-js/sha256';
import WorkIcon from '@mui/icons-material/Work';
import CallIcon from '@mui/icons-material/Call';
import EuroIcon from '@mui/icons-material/Euro';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import WidgetProgress from '../../../components/widgets/WidgetProgress';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tab, Tabs } from '@mui/material';


function QuestionnaireGarant({ _id = null, current = null, setCurrent = null, admin = false }) {
  var { id } = useParams();
  if (_id !== null) {
    id = _id;
  }

  const navigate = useNavigate();

  const [user, setUser] = React.useState(current);
  const [errors, setErrors] = React.useState([]);
  const [editable, setEditable] = React.useState(admin);
  const [open, setOpen] = React.useState(!admin);
  const handleChangeTab = (_, newValue) => {
    setCurrentPage(newValue);
  };
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (user === null) {
      axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
        .then((response) => {
          switch (response.status) {
            case 200:
              setUser(response.data);
              const tmpEditable = response.data.dossier.list_garants[id].questionnaire_etat === 'manquant' || response.data.dossier.list_garants[id].questionnaire_etat === 'attente' || response.data.dossier.list_garants[id].questionnaire_etat === 'rejet' || admin;
              setEditable(tmpEditable);
              break;

            default:
              break;
          }
        })
        .catch((e) => {
          let response = e.response;

          if (response === undefined) {
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            return;
          }

          switch (response.status) {
            case 401:
              navigate('/connexion');
              break;

            default:
              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
              break;
          }
        });
    }
  }, []);


  var formList = [];
  const pushReturn = (array, item) => { array.push(item); return item; };


  const [nom, setNom] = pushReturn(formList, React.useState(null));
  const [prenom, setPrenom] = pushReturn(formList, React.useState(null));
  const [email, setEmail] = pushReturn(formList, React.useState(null));
  const [telephone, setTelephone] = pushReturn(formList, React.useState(null));

  const [lienFamille, setLienFamille] = pushReturn(formList, React.useState(null));
  const [situationMatrimoniale, setSituationMatrimoniale] = pushReturn(formList, React.useState(null));
  const [revenuNet, setRevenuNet] = pushReturn(formList, React.useState(null));

  const [situationProfessionnelle, setSituationProfessionnelle] = pushReturn(formList, React.useState(null));
  const [enEssai, setEnEssai] = pushReturn(formList, React.useState(null));

  const [typeLogementActuel, setTypeLogementActuel] = pushReturn(formList, React.useState(null));


  const [currentPage, setCurrentPage] = React.useState(0);


  const nextPage = () => setCurrentPage(x => x + 1);
  const prevPage = () => setCurrentPage(x => x - 1);

  const saveAndNextPage = () => {
    let payload = {};

    for (var i = 0; i < formList.length; i++) {
      let [field, setField] = formList[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/client_save_garant/' + user._id + '/' + id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            nextPage();
            if (setCurrent !== null)
              setCurrent(response.data)
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  React.useEffect(() => {
    if (enEssai !== null && enEssai.value) {
      setEnEssai((s) => ({ ...s, error: true, errorMessage: "Un garant ne peut pas être en période d'essai" }));
    }
  }, [enEssai]);


  const submitQuestionnaire = () => {
    var formQuestionnaireValid = true;
    var errorPage = null;

    if (nom === null || nom.value === '') {
      setNom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (prenom === null || prenom.value === '') {
      setPrenom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (email === null || email.value === '') {
      setEmail((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (telephone === null || telephone.value === '') {
      setTelephone((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (lienFamille === null || lienFamille.value === '') {
      setLienFamille((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (typeLogementActuel === null || typeLogementActuel.value === '') {
      setTypeLogementActuel((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (situationMatrimoniale === null || situationMatrimoniale.value === '') {
      setSituationMatrimoniale((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (revenuNet === null || revenuNet.value === '') {
      setRevenuNet((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (situationProfessionnelle === null || situationProfessionnelle.value === '') {
      setSituationProfessionnelle((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (enEssai === null || enEssai.value) {
      setEnEssai((s) => ({ ...s, error: true, errorMessage: "Un garant ne peut pas être en période d'essai" }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (!formQuestionnaireValid) {
      setCurrentPage(errorPage);
      return;
    }


    let payload = {};

    for (var i = 0; i < formList.length; i++) {
      let [field, setField] = formList[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/client_submit_garant/' + user._id + '/' + id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            if (!admin)
              navigate('/client/dossier');
            if (setCurrent !== null)
              setCurrent(response.data)
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 412:
            setErrors(Object.keys(response.data.detail).map(key => (response.data.detail[key])));
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      {user &&
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Attention"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                L'ajout d'un/de garant(s) est un atout pour la recherche. Ils sont fortement demandés en cas de période d'essai et obligatoire en cas d'alternance.
                <br></br><br></br>
                Pour la majorité des agences :
                <br></br><br></br>
                <span className='underline'>Locataire en alternance</span> : les revenus du/des garant(s) doivent couvrir 3 fois le montant du loyer (revenus nets / 3 = loyer max).
                Les revenus des garants sont cumulables dans certains cas.
                <br></br><br></br>
                <span className='underline'>Locataire en CDI/CDD</span> : le garant vient simplement garantir la période d'essai, ses revenus doivent également couvrir 3 fois le montant du loyer.
                ATTENTION, même en présence d'un garant, ce sont toujours les revenus du locataire qui seront pris en compte pour le calcul du loyer max.
                Exemple : un CDI avec un revenu de 1500€ net pourra prétendre à un loyer d'environ 500€ (1500/3) même si les revenus des garants sont supérieurs.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>
          <div className='max-w-4xl mx-auto shrink-0'>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-6'>
              <div className='col-span-12 w-full text-center mb-2'>
                <h1>Informations personnelles <b>garant n°{parseInt(id) + 1}</b></h1>
                Les champs obligatoires apparaîtront en surbrillance si manquants.
              </div>
              <div className='col-span-12 w-full text-center'>
                <Tabs value={currentPage} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                  <Tab label="Informations personnelles" id="simple-tab-0" />
                  <Tab label="Finaliser" id="simple-tab-2" />
                </Tabs>
              </div>
            </div>
          </div>

          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 0) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <CallIcon fontSize='large'></CallIcon>
                </div>
                <div>
                  <h2>Informations de contact</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} value={user.dossier.list_garants[id].nom} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} value={user.dossier.list_garants[id].prenom} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} value={user.dossier.list_garants[id].email} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={telephone} setState={setTelephone} id={'telephone'} text={"Téléphone"} regex_key={"[+0-9 ]"} value={user.dossier.list_garants[id].telephone} readOnly={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <EuroIcon fontSize='large'></EuroIcon>
                </div>
                <div>
                  <h2>Situation actuelle</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={situationMatrimoniale} setState={setSituationMatrimoniale} id={'situation_matrimoniale'} text={"Situation matrimoniale"} value={user.dossier.list_garants[id].situation_matrimoniale} readOnly={!editable}
                  options={{
                    'celibataire': "Célibataire",
                    'union': "Union libre",
                    'pacse': "Pacsé",
                    'marie': "Marié",
                    'serpare': "Séparé",
                    'divorce': "Divorcé",
                    'veuf': "Veuf"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={lienFamille} setState={setLienFamille} id={'lien_famille'} text={"Lien famillial"} value={user.dossier.list_garants[id].lien_famille} readOnly={!editable}
                  options={{
                    'sibling': "Frère/soeur",
                    'parent': "Parent",
                    'grand_parent': "Grand-parent",
                    'famille_autre': "Famille autre",
                    'ami': "Ami",
                    'conjoint': "Conjoint",
                    'autre': "Autre...",
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeLogementActuel} setState={setTypeLogementActuel} id={'type_logement_actuel'} text={"Type de logement"} value={user.dossier.list_garants[id].type_logement_actuel} readOnly={!editable}
                  options={{
                    'locataire': "Locataire",
                    'proprietaire': "Propriétaire",
                    'heberge': "Hebergé"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={revenuNet} setState={setRevenuNet} id={'revenu_net'} text={"Revenu net"} regex_key={"[0-9\. ]"} value={user.dossier.list_garants[id].revenu_net} readOnly={!editable} />
                <span className='text-xs'>(Les agences immobilières demandent que le revenu net couvre 3 fois le montant du loyer)</span>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={situationProfessionnelle} setState={setSituationProfessionnelle} id={'situation_professionnelle'} text={"Situation professionnelle"} value={user.dossier.list_garants[id].situation_professionnelle} readOnly={!editable}
                  options={{
                    'salarie': "Salarié",
                    'publique': "Fonctionnaire",
                    'tns': "Chef d'entreprise/indépendant",
                    'retraite': "Retraité",
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 pt-2 pl-2'>
                <WidgetCheckbox state={enEssai} setState={setEnEssai} id={'en_essai'} text={"En période d'essai"} value={user.dossier.list_garants[id].en_essai} disabled={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined'
                  onClick={() => {
                    axios.post(CONFIG.API_URL + '/api/client_delete_garant/' + id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            navigate("/client/dossier");
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            break;
                        }
                      });
                  }}
                >
                  Supprimer le garant
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={(editable) ? saveAndNextPage : nextPage}>
                  {(editable) ? "Enregistrer et passer à la suite" : "Suivant"}
                </Button>
              </div>

              <div className='col-span-12 w-full mt-6 text-xs text-justify'>
                En tant que responsable de traitement, Mouv'Immo collecte vos données à caractère personnel aux fins notamment
                de la création et de la gestion de votre compte utilisateur, de l'instruction et le suivi de votre demande, de la réalisation
                d'enquêtes de satisfaction, d'études marketing et statistiques. Vos données sont destinées aux différents services
                administratifs, commercial, marketing de Mouv'Immo, aux organismes en charge de votre prise en charge et aux
                partenaires en charge de la recherche de biens. Vos données seront conservées le temps nécessaire à l'exécution des
                différentes démarches et selon notre politique de conservation des données. Les données mentionnées par un
                astérisque (*) sont obligatoires. Conformément à la Loi Informatique et Liberté Loi n° 78-17 du 6 janvier 1978 modifiée
                et au Règlement Général sur la Protection des Données Règlement (UE) 2016/679 du Parlement européen et du Conseil
                du 27 avril 2016 dit RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition
                au traitement de vos données. Vous pouvez exercer vos droits en envoyant un mail à agence@mouv-immo.com ou
                par courrier à Mouv'Immo, 16 rue Lieutenant-Colonel Prévost, 69006 Lyon. Pour plus d'informations concernant le
                traitement de vos données à caractère personnel, vous pouvez consulter notre politique en ligne.
              </div>
            </div>
          </div>













          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 1) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <PlaylistAddCheckIcon fontSize='large'></PlaylistAddCheckIcon>
                </div>
                <div>
                  <h2>Valider les réponeses</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-12 w-full mb-4'>
                {(editable) ? "En validant ce garant, il accepte de se porter caution pour tous les locataires présents dans le bail. Il accepte aussi d'être signataire et que son nom apparaisse dans le contrat de location." : "Réponses déjà validées."}
              </div>

              {errors.length !== 0 &&
                <div className='col-span-12 w-full mb-4 text-left'>
                  <Alert severity="error">
                    <AlertTitle>Erreur</AlertTitle>
                    <ul className='list-disc list-inside'>
                      {errors.map((x) => <li key={x}>{x}</li>)}
                    </ul>
                  </Alert>
                </div>
              }
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined' onClick={prevPage}>
                  Précédent
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={submitQuestionnaire} disabled={!editable}>
                  Valider mes réponses
                </Button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
}

export default QuestionnaireGarant;